import type { RunReportPortfolioFilters } from '../../types/runTable.types';
import { hasActivePortfolioFilters } from '../runTable/runReportPortfolioFilters';
import {
  AUTO_FULL_FETCH_LIMIT,
  FILTER_FULL_FETCH_MAX,
  REPORTS_PAGE_SIZE,
} from './constants';

export const resolveReportsFetchPageSize = (
  succeeded: number,
  portfolioFilters: RunReportPortfolioFilters,
): number => {
  if (succeeded <= 0) {
    return REPORTS_PAGE_SIZE;
  }

  if (
    succeeded <= AUTO_FULL_FETCH_LIMIT ||
    hasActivePortfolioFilters(portfolioFilters)
  ) {
    return Math.min(succeeded, FILTER_FULL_FETCH_MAX);
  }

  return REPORTS_PAGE_SIZE;
};

export const resolveStreamingReportsPageSize = (total: number): number => {
  if (total <= 0) {
    return REPORTS_PAGE_SIZE;
  }

  return Math.min(total, FILTER_FULL_FETCH_MAX);
};

export const resolveReportsFullyLoaded = (
  runTotal: number,
  streamingReportsPageSize: number,
): boolean => runTotal > 0 && streamingReportsPageSize >= runTotal;

export const resolveReportsPaginationOffset = (
  reportsFetchPageSize: number,
  succeeded: number,
  reportsPage: number,
): number =>
  reportsFetchPageSize >= succeeded ? 0 : (reportsPage - 1) * REPORTS_PAGE_SIZE;
